__turbopack_context__.v({
  "className": "plus_jakarta_sans_71b85382-module__v9MXQG__className",
});
